// County data is DB-backed (`county` table / GET /counties-list), same source as the
// server's ValidCountyForState rule - no bundled county list on the frontend.
export function fetchCountiesForState($http, stateCd) {
    let state = (stateCd || '').trim().toUpperCase();
    if (!state) {
        return Promise.resolve([]);
    }

    return $http.get('/counties-list', { params: { state_cd: state } }).then(function (response) {
        return response.data || [];
    });
}

export function clearCountyIfInvalid(address, countyList) {
    if (address.country_cd !== 'US' || !address.county) {
        return;
    }

    let current = String(address.county).trim().toLowerCase();
    let stillValid = countyList.some(function (county) {
        return county.toLowerCase() === current;
    });

    if (!stillValid) {
        address.county = '';
    }
}

// Presence check only (US only) - clearCountyIfInvalid() above is what actually enforces
// a real value, so by submit time a non-empty county has already been validated.
export function isCountyValid(addr) {
    if (!addr || addr.country_cd !== 'US') {
        return true;
    }

    return !!(addr.county && String(addr.county).trim().length > 0);
}



// WEBPACK FOOTER //
// ./resources/assets/js/components/address/sanitizeCounty.js